import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor(props) {
        super();
        this.url = new URL(window.location);
        this.entity = this.url.searchParams.get('entities:in');
        this.query = query({ entity: this.entity, domain: props.domain });
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        if (this.props.from_gsc && (!this.state.data || !this.state.data.length))
            return <div>{t('discover.entity.no_found')}</div>;

        const item = (
            <div className="google-trends-btn">
                <a
                    href={`https://trends.google.com/trends/explore?q=${this.props.entity}&date=today 12-m&geo=${this.props.user_geo_location_geo}&hl=en`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <div className="google-trends-btn-img">
                        <img src="/static/img/google-trends.png" loading="lazy" />
                    </div>{' '}
                    {t('discover.entity.trends_btn_name')}
                    <i className="icon-arrow-right1" />
                </a>
            </div>
        );
        return (
            <Timeline
                data={this.state.data}
                keys={keys(this.state.isDark, t)}
                forceRun={this.forceRun}
                content_id={this.props.content_id}
                parent_id={this.props.parent_id}
                hasRightAxis
                rightAxisLabel={t('discover.global.ctr_per')}
                hasLeftSecondAxis
                extraBox={item}
                leftSecondAxisLabel={t('discover.global.clicks')}
                leftAxisLabel={t('discover.global.impressions')}
                chartSize="lg"
                metricType="primary"
                chartContainerStyles="d-flex justify-content-between"
            />
        );
    }
}

export default withTranslation()(Summary);
